import SiteLayout from "@/components/feature/SiteLayout";
import PageHero from "@/components/base/PageHero";
import SectionDivider from "@/components/base/SectionDivider";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import WhySection from "@/pages/home/components/WhySection";
import CtaSection from "@/pages/home/components/CtaSection";

export default function Why() {
  useDocumentMeta({
    title: "Neden d.mar | Şişli Dental Görüntüleme Merkezi",
    description:
      "14+ yıllık tecrübe, modern CBCT cihaz altyapısı, düşük doz dijital çekim ve aynı gün rapor. d.mar, diş hekimlerinin güvendiği görüntüleme ortağı.",
    path: "/neden-dmar",
  });

  return (
    <SiteLayout>
      <PageHero
        crumb="Neden d.mar"
        eyebrow="Neden d.mar?"
        title="Diş hekimlerinin güvendiği görüntüleme ortağı"
        description="Modern dijital cihaz altyapısı, uzman teknik kadro ve aynı gün rapor teslimiyle İstanbul'un merkezinde güvenilir dental radyoloji hizmeti."
      />
      <WhySection />
      <SectionDivider />
      <CtaSection />
    </SiteLayout>
  );
}